import { useEffect, useState } from 'react';

export const useResponsiveChartHeight = (base: number): number => {
    const compute = () => {
        if (typeof window === 'undefined') return base;
        const scale = Math.min(1.3, Math.max(0.72, window.innerWidth / 1440));
        return Math.round(base * scale);
    };

    const [height, setHeight] = useState<number>(compute);

    useEffect(() => {
        const onResize = () => setHeight(compute());
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [base]);

    return height;
};
